/**
 * /ninety/job-notes — My Day · Job Notes tab.
 *
 * VISUAL REFERENCE build for the development team: every job and note comes
 * from the fake in-memory store in ~/components/myday/store.ts (no Supabase).
 * Add / edit / delete notes, edit jobs and filtering all work in-session and
 * reset on reload.
 */
import { createFileRoute } from '@tanstack/react-router';
import { JobNotesView } from '~/components/myday/jobnotes/JobNotesView';

export const Route = createFileRoute('/_app/ninety/job-notes')({
  component: JobNotesTab,
});

function JobNotesTab() {
  return (
    <div className="px-4 sm:px-6 py-4">
      <JobNotesView />
    </div>
  );
}
